/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Jpc_AriaInputs */

const es_cap_jpc_aria = /** @type {(inputs: Cap_Jpc_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejemplo de propuesta de salida`)
};

const gl_cap_jpc_aria = /** @type {(inputs: Cap_Jpc_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exemplo de proposta de saída`)
};

const en_cap_jpc_aria = /** @type {(inputs: Cap_Jpc_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sample trip proposal`)
};

/**
* | output |
* | --- |
* | "Sample trip proposal" |
*
* @param {Cap_Jpc_AriaInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_jpc_aria = /** @type {((inputs?: Cap_Jpc_AriaInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Jpc_AriaInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_jpc_aria(inputs)
	if (locale === "en") return en_cap_jpc_aria(inputs)
	return es_cap_jpc_aria(inputs)
});